<div [formGroup]="form()">
  <!-- Date from and to -->
  @let dateFromCtrlDisabled = this.form().controls.dateFrom.disabled;
  @let dateToCtrlDisabled = this.form().controls.dateTo.disabled;
  @let dateCtrlsDisabled = dateFromCtrlDisabled && dateToCtrlDisabled;
  <div
    id="date-group"
    class="k-d-grid k-align-items-center k-mb-6"
    [ngClass]="{ 'k-form-field-disabled': dateCtrlsDisabled }"
  >
    <kendo-label class="k-w-1/4 k-mr-2.5 !k-mt-0" [for]="dateFrom" text="Datum"> </kendo-label>
    <div class="input-fields k-d-grid k-align-items-center">
      <kendo-formfield orientation="horizontal" class="!k-mt-0 !k-mb-0">
        <kendo-datepicker
          [formControlName]="timeDialogFormControls.DateFrom"
          #dateFrom
          appAfterValueChanged
          (afterValueChanged)="form().markAllAsTouched()"
        ></kendo-datepicker>
      </kendo-formfield>

      <span class="k-text-center k-mt-0 k-ml-5.5 k-mr-5.5 k-label">bis</span>

      <kendo-formfield orientation="horizontal" class="k-justify-content-end !k-mt-0 !k-mb-0">
        <kendo-datepicker
          [formControlName]="timeDialogFormControls.DateTo"
          appAfterValueChanged
          (afterValueChanged)="form().markAllAsTouched()"
        ></kendo-datepicker>
      </kendo-formfield>
    </div>
  </div>

  @let timeFromCtrlDisabled = this.form().controls.timeFrom.disabled;
  @let timeToCtrlDisabled = this.form().controls.timeTo.disabled;
  @let timeCtrlsDisabled = timeFromCtrlDisabled && timeToCtrlDisabled;
  @if (intervalSelectable()) {
    <div id="time-of-day-selection" class="k-d-grid k-mb-2.5">
      <div class="k-d-flex">
        <div class="k-form-field-radiobutton-wrap k-d-flex">
          <kendo-radiobutton
            [value]="IntervalTypes.FixInterval"
            #fixInterval
            [formControlName]="timeDialogFormControls.Interval"
          ></kendo-radiobutton>
          <kendo-label class="k-radio-label" [for]="fixInterval" text="Arbeitszeit"></kendo-label>
        </div>
        <div class="k-form-field-radiobutton-wrap k-d-flex k-ml-4.5">
          <kendo-radiobutton
            [value]="IntervalTypes.VariableInterval"
            #variableInterval
            [formControlName]="timeDialogFormControls.Interval"
          ></kendo-radiobutton>
          <kendo-label class="k-radio-label" [for]="variableInterval" text="Uhrzeit"></kendo-label>
        </div>
      </div>
    </div>
  }

  @if (fixIntervalDropdownVisible()) {
    <kendo-formfield orientation="horizontal" class="!k-mb-2">
      <kendo-label class="!k-align-items-start" [for]="reason" text="Arbeitszeit"></kendo-label>
      <kendo-dropdownlist
        textField="text"
        valueField="value"
        [formControlName]="timeDialogFormControls.TimeOfDay"
        #reason
        [data]="TimeOfDayValues"
      >
        <ng-template kendoDropDownListValueTemplate let-dataItem>
          <ng-container>
            <span>{{ dataItem?.text }}</span>
          </ng-container>
        </ng-template>
      </kendo-dropdownlist>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>
  } @else {
    <!-- Time from and to -->
    <div
      id="time-group"
      class="k-d-grid k-align-items-center k-mb-2"
      [ngClass]="{ 'k-form-field-disabled': timeCtrlsDisabled }"
    >
      <kendo-label class="k-w-1/4 k-mr-2.5 !k-mt-0" [for]="timeFrom" text="Uhrzeit"> </kendo-label>
      <kendo-formfield orientation="horizontal" class="!k-mt-0 !k-mb-0">
        <kendo-timepicker
          [popupSettings]="{
            appendTo: vcRef,
          }"
          [formControlName]="timeDialogFormControls.TimeFrom"
          #timeFrom
          appAfterValueChanged
          (afterValueChanged)="form().markAllAsTouched()"
        >
        </kendo-timepicker>
      </kendo-formfield>

      <span class="k-text-center k-mt-0 k-ml-5.5 k-mr-5.5 k-label">bis</span>

      <kendo-formfield orientation="horizontal" class="!k-mt-0 !k-mb-0">
        <kendo-timepicker
          [popupSettings]="{
            appendTo: vcRef,
          }"
          #timeTo
          [formControlName]="timeDialogFormControls.TimeTo"
          appAfterValueChanged
          (afterValueChanged)="form().markAllAsTouched()"
        >
        </kendo-timepicker>
      </kendo-formfield>
    </div>
  }
</div>
